import type { CopilotChatMessage } from '../copilot/types';
import type { StoredChatMessage } from './chatHistoryTypes';

type ProposalMeta = {
  proposal?: {
    id: string;
    proposalType: string;
    status: string;
  };
};

export function mapStoredMessagesToCopilot(messages: StoredChatMessage[]): CopilotChatMessage[] {
  return messages.map((msg) => {
    const meta = (msg.metadata ?? null) as ProposalMeta | null;
    const proposal = meta?.proposal;
    return {
      id: msg.id,
      role: msg.role,
      text: msg.text,
      domain: msg.domain as CopilotChatMessage['domain'],
      proposal: proposal
        ? {
            id: proposal.id,
            proposalType: proposal.proposalType,
            status: proposal.status === 'confirmed' ? 'confirmed' : 'pending',
          }
        : undefined,
    };
  });
}

export function mapStoredMessagesToInvestigator(
  messages: StoredChatMessage[],
): { id: string; role: 'user' | 'assistant'; text: string }[] {
  return messages.map((msg) => ({
    id: msg.id,
    role: msg.role,
    text: msg.text,
  }));
}
